import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { PqrTypeFilters } from './filters';
import { PqrTypeList } from './list';
import { PQR_TYPE, PQR_TYPE_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const PqrType = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de Tipo PQR"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_TYPE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_TYPE,
                        }}
                    />
                }
            >
                <PqrTypeFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <PqrTypeList filters={filters} />
        </>
    );
};
